import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { useForm } from "../../hooks/useForm";
import {
  deleteImageStorageService,
  getAllImagesStorageService,
} from "../../selectors/imageStorageService";
import { permisos } from "../../helper/permissions";

export const ListImageStorage = () => {
  const seccion = 'Galeria'
  permisos(seccion, 'listar', 'alerta')
  const hasListarPermission = permisos(seccion, 'listar')
  const hasEditarPermission = permisos(seccion, 'editar')
  const hasVerPermission = permisos(seccion, 'ver')
  const hasBorrarPermission = permisos(seccion, 'borrar')
  const hasCrearPermission = permisos(seccion, 'crear')

  
  const [listImages, setListImages] = useState([]);
  const [page, setPages] = useState({});
  const [formValues, handleInputChange] = useForm({
    searchText: "",
  });
  let classBg = "bg-[#fff]";
  useEffect(() => {
    getAllImagesStorageService()
      .then((resp) => {
        console.log(resp)
        if (resp.data.success) {
          setListImages(resp.data.data.data);
          setPages(resp.data.data.paginacion);
          localStorage.setItem("listImages", JSON.stringify(resp.data.data.data));
        } else {
          if (resp.data.code == 401) {
            swal({
              title: "Alerta!!!",
              text: `${resp.data.data.message}`,
              icon: "warning",
              dangerMode: true,
            }).then(function () {
              window.location = "/bienvenido";
            });
          } else {
            swal({
              title: "Error",
              text: `Error: ${JSON.stringify(resp.data.data.message)}`,
              icon: "error",
              dangerMode: true,
            });
          }

        }
      })
      .catch((error) => {
        swal({
          title: "Error",
          text: `Sucedió un error: ${error}`,
          icon: "error",
          dangerMode: true,
        });
      });
  }, []);
  const { searchText } = formValues;
  const handleSearch = (event) => {
    event.preventDefault();
    getAllImagesStorageService(1, searchText)
      .then((resp) => {
        console.log(resp)
        if (resp.data.success) {
          setListImages(resp.data.data.data);
          setPages(resp.data.data.paginacion);
          localStorage.setItem("listImages", JSON.stringify(resp.data.data.data));
        } else {
          if (resp.data.code == 401) {
            swal({
              title: "Alerta!!!",
              text: `${resp.data.data.message}`,
              icon: "warning",
              dangerMode: true,
            }).then(function () {
              window.location = "/bienvenido";
            });
          } else {
            swal({
              title: "Error",
              text: `Error: ${JSON.stringify(resp.data.data.message)}`,
              icon: "error",
              dangerMode: true,
            });
          }


        }
      })
      .catch((error) => {
        swal({
          title: "Error",
          text: `Sucedió un error: ${error}`,
          icon: "error",
          dangerMode: true,
        });
      });
  };
  const handleClick = (imagenId) => {
    swal({
      title: "Alerta!!!",
      text: "¿Esta seguro que desea eliminar el resgistro?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        let nuevaListaImagenes = listImages.filter(
          (imagen) => imagen.id !== imagenId
        );
        deleteImageStorageService(imagenId)
          .then((resp) => {
            if (resp.data.success) {
              setListImages(nuevaListaImagenes);
              swal("Imagen Eliminado con Éxito", {
                icon: "success",
              });
            } else {
              if (resp.data.code == 401) {
                swal({
                  title: "Alerta!!!",
                  text: `${resp.data.data.message}`,
                  icon: "warning",
                  dangerMode: true,
                }).then(function () {
                  window.location = "/bienvenido";
                });
              } else {
                swal({
                  title: "Error",
                  text: `Error: ${JSON.stringify(resp.data.data.message)}`,
                  icon: "error",
                  dangerMode: true,
                });
              }

            }
          })
          .catch((error) => {
            swal({
              title: "Error",
              text: `Sucedió un error: ${error}`,
              icon: "error",
              dangerMode: true,
            });
          });
      } else {
        swal("No se alteró la base de datos");
      }
    });
  };
  const handleBackPage = (pageBack) => {
    getAllImagesStorageService(pageBack - 1, searchText).then((resp) => {
      if (resp.data.success) {
        localStorage.setItem('listImages', JSON.stringify(resp.data.data.data))

        setListImages(resp.data.data.data);
        setPages(resp.data.data.paginacion);
      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }
  const handleNextPage = (page) => {
    getAllImagesStorageService(page + 1, searchText).then((resp) => {
      if (resp.data.success) {
        localStorage.setItem('listImages', JSON.stringify(resp.data.data.data))

        setListImages(resp.data.data.data);
        setPages(resp.data.data.paginacion);
      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }

  const handleFirstPage = (page) => {
    getAllImagesStorageService(1, searchText).then((resp) => {
      if (resp.data.success) {
        localStorage.setItem('listImages', JSON.stringify(resp.data.data.data))

        setListImages(resp.data.data.data);
        setPages(resp.data.data.paginacion);
      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }

  const handleLastPage = (page) => {
    getAllImagesStorageService(page, searchText).then((resp) => {
      if (resp.data.success) {
        localStorage.setItem('listImages', JSON.stringify(resp.data.data.data))

        setListImages(resp.data.data.data);
        setPages(resp.data.data.paginacion);
      } else {
        if (resp.data.code == 401) {
          swal({
            title: "Alerta!!!",
            text: `${resp.data.data.message}`,
            icon: "warning",
            dangerMode: true,
          }).then(function () {
            window.location = "/bienvenido";
          });
        }
      }
    }).catch((error) => {
      swal({
        title: "Error",
        text: `Sucedió un error: ${error}`,
        icon: "error",
        dangerMode: true,
      });
    });
  }
  return (
    <>
      {
        hasListarPermission && (
          <div className="flex flex-col px-5 mt-5">
            <div className="overflow-x-auto">
              <div className="p-5 inline-block min-w-full bg-[#67b5dd] rounded-[12px] mb-5 ">
                <div className="p-3">
                  <div className="buscador">
                    <form onSubmit={handleSearch}>
                      <div className="flex">
                        <div className="w-full">
                          <input
                            type="text"
                            className="rounded-[12px] form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none mr-3"
                            id="exampleFormControlInput1"
                            placeholder="Buscar"
                            name="searchText"
                            autoComplete='off'
                            value={searchText}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="pl-5">
                          <button
                            type="submit"
                            className=" py-2.5 bg-[#93b33a] text-white Metropolis-Bold text-xs leading-tight uppercase rounded-md shadow-md hover:bg-[#93b33a] hover:shadow-lg focus:bg-[#93b33a] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#93b33a] active:shadow-lg transition  pl-3 pr-3 duration-150 ease-in-out"
                          >
                            Buscar
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className='grid justify-items-center bg-[#243F59] bg-opacity-30 rounded-t-xl ml-3 mr-3'>
                  <span>
                    {page.onFirstPage !== true ?
                      <button onClick={(event) => handleFirstPage(page.currentPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">◀◀</button>
                      :
                      <button disabled onClick={(event) => handleFirstPage(page.currentPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">◀◀</button>
                    }

                    {page.onFirstPage !== true ?
                      <button onClick={(event) => handleBackPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">◀</button>
                      :
                      <button disabled onClick={(event) => handleBackPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">◀</button>
                    }

                    <span className="bg-white rounded px-4 py-2 text-base text-[#243F59] Metropolis mt-5 ml-1 mr-1">Página <b>{page.currentPage}</b> de <b>{page.lastPage}</b></span>

                    {page.hasMorePages === true ?
                      <button onClick={(event) => handleNextPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">▶</button>
                      :
                      <button disabled onClick={(event) => handleNextPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">▶</button>
                    }

                    {page.hasMorePages !== false ?
                      <button onClick={(event) => handleLastPage(page.lastPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">▶▶</button>
                      :
                      <button disabled onClick={(event) => handleLastPage(page.lastPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">▶▶</button>
                    }

                    <span className="bg-white rounded px-4 py-2 text-base text-[#243F59] Metropolis mt-5 ml-1 mr-1"><b>{page.total}</b> Registros</span>
                  </span>
                </div>
                <div className="overflow-hidden">
                  <table className="min-w-full border-x border-[#243F59] text-center rounded-[12px] overflow-hidden">
                    <thead className="border-x bg-[#243f59] rounded-[12px]">
                      <tr>
                        <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                          #
                        </th>
                        <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                          Nombre
                        </th>
                        <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                          Tipo
                        </th>
                        <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                          Descripción
                        </th>
                        <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r bg-[#243f5926] w-44">
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className="border-b bg-[#fff]">
                      {listImages.map((image, index) => {
                        if (index % 2 === 0) {
                          classBg = "bg-[#ececec]";
                        } else {
                          classBg = "bg-[#fff]";
                        }
                        return (
                          <tr key={index} className={`border-b ${classBg}`}>
                            <td className="bg-[#243f5926]">{index + 1}</td>
                            <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r">{image.title}</td>
                            <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r">{image.type}</td>
                            <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r">{image.description}</td>
                            <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r bg-[#243f5926]">
                              <div className="flex justify-center">
                                {hasEditarPermission && (
                                  <Link
                                    className="text-blue-600 visited:text-black-600"
                                    to={`./edit/${image.id}`}
                                  >
                                    {" "}
                                    <img
                                      className="w-7 cursor-pointer"
                                      src={`/assets/icons/edit.png`}
                                      alt="Editar"
                                      title="Editar"
                                    />
                                  </Link>
                                )}

                                {hasVerPermission && (
                                  <Link
                                    className="text-blue-600 visited:text-black-600"
                                    to={`./view/${image.id}`}
                                  >

                                    <img
                                      className="w-7 cursor-pointer"
                                      src={`/assets/icons/details.png`}
                                      alt="Ver Detalles"
                                      title="Ver Detalles"
                                    />
                                  </Link>
                                )}
                                <div>
                                  <img
                                    onClick={(event) =>
                                      navigator.clipboard.writeText(
                                        `${process.env.REACT_APP_IMAGES_URL}${image.picture}`
                                      )
                                    }
                                    src={`/assets/icons/paste.png`}
                                    alt="Copiar URL"
                                    title="Copiar URL"
                                    className="w-7 cursor-pointer "
                                  />
                                </div>&nbsp;

                                {hasBorrarPermission && (
                                  <img
                                    onClick={(event) => handleClick(image.id)}
                                    className="w-7 cursor-pointer"
                                    src={`/assets/icons/delete.png`}
                                    alt="Eliminar"
                                    title="Eliminar"
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className='grid justify-items-center bg-[#243F59] bg-opacity-30 rounded-b-xl ml-3 mr-3'>
                  <span>
                    {page.onFirstPage !== true ?
                      <button onClick={(event) => handleFirstPage(page.currentPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">◀◀</button>
                      :
                      <button disabled onClick={(event) => handleFirstPage(page.currentPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">◀◀</button>
                    }

                    {page.onFirstPage !== true ?
                      <button onClick={(event) => handleBackPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">◀</button>
                      :
                      <button disabled onClick={(event) => handleBackPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">◀</button>
                    }

                    <span className="bg-white rounded px-4 py-2 text-base text-[#243F59] Metropolis mt-5 ml-1 mr-1">Página <b>{page.currentPage}</b> de <b>{page.lastPage}</b></span>

                    {page.hasMorePages === true ?
                      <button onClick={(event) => handleNextPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">▶</button>
                      :
                      <button disabled onClick={(event) => handleNextPage(page.currentPage)} className="bg-[#243F59] rounded px-4 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">▶</button>
                    }

                    {page.hasMorePages !== false ?
                      <button onClick={(event) => handleLastPage(page.lastPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1">▶▶</button>
                      :
                      <button disabled onClick={(event) => handleLastPage(page.lastPage)} className="bg-[#243F59] rounded px-3 py-2 text-base text-white Metropolis-Bold mb-3 mt-3 ml-1 mr-1 cursor-not-allowed opacity-50">▶▶</button>
                    }

                    <span className="bg-white rounded px-4 py-2 text-base text-[#243F59] Metropolis mt-5 ml-1 mr-1"><b>{page.total}</b> Registros</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};
